import { Immutable } from "immer";
import React from "react";

import { PLCBooleanOptionSelector } from "../PLCBooleanOptionSelector";
import {
    IPLCBooleanOptionSelectorGroup,
    IPLCOptionPanel,
    IPLCProductCategorySelector,
} from "../models";

// Load styles
import "./index.scss";

type IProps = Immutable<{
    categorySelectors: readonly IPLCProductCategorySelector[];
    optionPanels: readonly IPLCOptionPanel[];
    group: IPLCBooleanOptionSelectorGroup;
}>;

const BEM_NAME = "plc-boolean-option-selector-group";

export const PLCBooleanOptionSelectorGroup = (
    props: IProps,
): React.ReactNode => {
    const groupID = props.group.id;
    return (
        <fieldset className={BEM_NAME}>
            <ul>
                {props.group.value.selectors.map((selector) => (
                    <PLCBooleanOptionSelector
                        key={selector.name}
                        categorySelectors={props.categorySelectors}
                        optionPanels={props.optionPanels}
                        groupID={groupID}
                        selector={selector}
                    />
                ))}
            </ul>
        </fieldset>
    );
};
